export const getCumulativeQuestionIndex = (sectionIndex, testDetail) => {
  // console.log(sectionIndex,"sectionIndex");
  let totalQuestions = 0;
  for (let i = 0; i < sectionIndex; i++) {
    totalQuestions += parseInt(
      testDetail?.sectionDetails[i]?.questionPerSection || 0
    );
  }
  return totalQuestions;
};

export const getIndex = (sectionIndex, testDetail) => {
  // console.log(sectionIndex,"sectionIndex");
  let index = 0;
  for (let i = 0; i < sectionIndex; i++) {
    index += parseInt(testDetail?.sectionDetails[i]?.questionPerSection || 0);
  }
  return index;
};
